import React, { useState, useEffect } from 'react';
import { Container, BottomNavigation, BottomNavigationAction, Box } from '@mui/material';
import HomeIcon from "@mui/icons-material/Home";
import TourIcon from "@mui/icons-material/Event";
import PersonIcon from "@mui/icons-material/Person";
import { router, usePage } from '@inertiajs/react';
import theme from '../../styles/theme'
import { ThemeProvider } from '@mui/material/styles';
import { Header } from '../Header';
import { useMediaQuery } from '@mui/material';
import { useAuth } from '../../hooks/useAuth';

interface ProspectMainLayoutProps {
    children: React.ReactNode;
    headerText?: React.ReactNode;
    headerButton?: React.ReactNode;
    activeTab?: 'home' | 'tours' | 'profile';
    onTabChange?: (tab: 'home' | 'tours' | 'profile') => void;
}

const ProspectMainLayout: React.FC<ProspectMainLayoutProps> = ({ children, headerText, headerButton, activeTab = 'home', onTabChange }) => {
    const isDesktop = useMediaQuery('(min-width: 600px)');
    const contentWidth = isDesktop ? '500px' : '97%';
    const { url } = usePage();
    const [currentPage, setCurrentPage] = useState(activeTab);
    const { renter } = useAuth();

    useEffect(() => {
        setCurrentPage(activeTab);
    }, [activeTab]);

    const handleHomeClick = () => {
        if (onTabChange) {
            onTabChange('home');
        } else {
            router.visit(`/renters/${renter?.id}/home`);
        }
    };

    const handleToursClick = () => {
        if (onTabChange) {
            onTabChange('tours');
        } else {
            router.visit(`/renters/${renter?.id}/tours`);
        }
    };

    const handleProfileClick = () => {
        if (onTabChange) {
            onTabChange('profile');
        } else {
            router.visit(`/renters/${renter?.id}/profile`);
        }
    };

    return (
        <ThemeProvider theme={theme}>
            <Container maxWidth={false} sx={{ p: 0, mt: 0, ml: 0, mr: 0, mb: 10, width: '100%', display: 'flex', flexDirection: 'column', minHeight: '100vh', alignItems: 'center' }}>
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                    <Box sx={{ width: contentWidth, display: 'flex', flexDirection: 'column', gap: 3 }}>
                        <Header headerText={headerText} headerButton={headerButton} />
                        {children}
                    </Box>
                </Box>
                <BottomNavigation
                    showLabels
                    value={currentPage}
                    sx={{
                        position: "fixed",
                        bottom: 0,
                        left: 0,
                        right: 0,
                        maxWidth: '100%',
                        borderTop: '1px solid #eee',
                        boxShadow: '0px -2px 10px rgba(0,0,0,0.05)'
                    }}
                >
                    <BottomNavigationAction
                        label="Home"
                        icon={<HomeIcon />}
                        onClick={handleHomeClick}
                        value="home"
                    />
                    <BottomNavigationAction
                        label="Tours"
                        icon={<TourIcon />}
                        onClick={handleToursClick}
                        value="tours"
                    />
                    <BottomNavigationAction
                        label="Profile"
                        icon={<PersonIcon />}
                        onClick={handleProfileClick}
                        value="profile"
                    />
                </BottomNavigation>
            </Container>
        </ThemeProvider>
    );
};

export default ProspectMainLayout;
